import { useCurrentUser, useRedirectPrevPage } from 'hooks'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { TypeRoute } from 'core/TypeRoute'
import { useToast } from 'contexts'
import { FullScreenLoading } from 'components/core/FullScreenLoading'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

export const RedirectPage = () => {
  const redirect = useRedirectPrevPage()
  const navigate = useNavigate()
  const { showToast } = useToast()
  const { isLoading, isSignedIn } = useCurrentUser()
  const redirectUrl = useSelector<RootState>(
    (state) => state.redirect.redirectUrl,
  ) as string | null

  useEffect(() => {
    if (isLoading) {
      return
    }

    // This is a bit tricky but amplify will need a short time to update the token before updating the url to /redirect
    // This race condition causes the issue that the new page is loaded but the URL is still /redirect
    // I put this delay to make a trick to keep the url correct.
    const timeoutId = setTimeout(() => {
      redirectUrl ? redirect() : navigate(TypeRoute.Home)
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [navigate, redirect, showToast, isSignedIn, isLoading, redirectUrl])

  return <FullScreenLoading />
}
